import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import "./MainBasket.scss";
import PriceCard from "./PriceCard/PriceCard";
import ListOrder from "./ListOrder/ListOrder";
import AddressSelect from "./AddressSelect/AddressSelect";
import DynaButton from "../DynaView/DynaButton";
import DetailOrder from "./DetailOrder/DetailOrder";
import pic from "../../Assets/images/saderat.png";
import Title from "../Title/Title";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import ProductCardContainer from "../ProductCard/ProductCardContainer";
import {
	SaleContext,
	SetDiscountContext,
	SetSaleContext,
} from "../pages/Pages";
import { prefixUrl } from "../../Utils/utilsData";
import Loader from "../Loader/Loader";
import SmallModal from "../ModalPages/SmallModal";
import WalletPopupIcon from "../../Assets/svg/wallet-icon-popup.svg";
import DiscountCode from "./DiscountCode/DiscountCode";

const MainBasket = () => {
	const [stepManage, setStepMange] = useState(1);
	const [buttonCaption, setButtonCaption] = useState("انتخاب آدرس");
	const [titleCaption, setTitleCaption] = useState("سبد خرید");
	const [shopList, setShopList] = useState({ cartItems: [], products: [] });
	const [addressData, setAddressData] = useState({});
	const [detailOrderData, setDetailOrderData] = useState({});
	const [reMake, setReMake] = useState(0);
	const saleNum = useContext(SaleContext);
	const setSaleNum = useContext(SetSaleContext);
	const [setBasketNum] = useState("");
	const Navigate = useNavigate();
	const discountContext = useContext(SetDiscountContext);
	const [sendData, setSendData] = useState({
		billId: "",
		sendingDate: "",
		sendingTime: "",
		addressId: "",
		type: "",
		orderType: "سایت",
	});
	const [factorTotal, setFactorTotal] = useState({
		mainPrice: [0],
		discount: [0],
		totalDiscount: [0],
		total: [0],
		sendPrice: 0,
		sumTe: [0],
	});
	const [isLoad, setIsLoad] = useState(false);
	const [productError, setProductError] = useState([]);

	const savedPro =
		localStorage.getItem("products") !== "" &&
		JSON.parse(localStorage.getItem("products"));
	// const concatItems = (items) => {
	//   const localItems = localStorage.getItem("products");
	//   if (localItems === "" || localItems.length === 0) {
	//   } else {
	//     items.forEach((product) => {
	//       let matchedProduct = savedPro.find((item) => item.id === product.id);
	//       if (matchedProduct) {
	//         product.count = +product.count + +matchedProduct.count;
	//       }
	//     });
	//   }
	//   localStorage.setItem("products", JSON.stringify(items));
	// };
	const [weightTypes, setWeightTypes] = useState([]);

	useEffect(() => {
		const pros =
			localStorage.getItem("products") === ""
				? ""
				: JSON.parse(localStorage.getItem("products"));

		axios.get(`${prefixUrl()}/cart/get.php`).then((response) => {
			if (response.data.status) {
				setShopList({
					cartItems: pros,
					products: response.data.output.products,
				});

				let temp = [];
				pros.forEach((v) => {
					if (+v.count > +v.inventory || v.inventory === "ناموجود") {
						temp.push({ id: v.id, count: v.inventory });
					}
				});
				setProductError(temp);

				if (pros !== "") {
					setWeightTypes(pros.filter((item) => item.type === 2));
				}
				setFactorTotal((prevState) => {
					return {
						...prevState,
						sendPrice: response.data.output.shippingCost,
					};
				});
				setIsLoad(true);
			} else {
				toast.error("خطا در بر قراری ارتباط");
			}
		});
	}, [reMake]);

	useEffect(() => {
		const pros =
			localStorage.getItem("products") === ""
				? ""
				: JSON.parse(localStorage.getItem("products"));
		setShopList({ ...shopList, cartItems: pros });
	}, [saleNum]);

	useEffect(() => {
		if (sendData.billId !== "") {
			sendSubmitedData();
		}
	}, [sendData.billId]);

	const sendFactor = async () => {
		try {
			let sendData = JSON.parse(localStorage.getItem("products"));
			let newSendData = [];
			sendData.forEach((v) => {
				if (v.type === 1) {
					newSendData.push({ id: v.id, count: v.count });
				} else {
					const myCount = (
						+v.count.toFixed(1) / +v.defultValue
					).toFixed(1);
					newSendData.push({ id: v.id, count: +myCount });
				}
			});
			const response = await axios.post(`${prefixUrl()}/cart/add.php`, {
				product: newSendData,
			});
			if (response.data.status) {
				await submitData("billId", response?.data?.output?.factorId);
				setBasketNum(0);
			} else {
				setStepMange(1);
				setProductError(response.data.errors);
				toast.error("موجودی کافی نیست");
			}
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};

	const mainActionButton = () => {
		if (stepManage === 1) {
			if (shopList.cartItems.length > 0) {
				let hasEmpty = { name: "", state: false };
				let hasNotEnough = { name: "", state: false };
				shopList.cartItems.forEach((item) => {
					if (item.inventory === 0) {
						hasEmpty = { name: item.title, state: true };
					}
					if (item.count > item.inventory) {
						hasNotEnough = { name: item.title, state: true };
					}
				});
				if (hasEmpty.state === true) {
					return toast.error(`${hasEmpty.name} موجود نمی باشد`);
				}
				if (hasNotEnough.state === true) {
					return toast.error(
						`${hasNotEnough.name} به این تعداد موجود نمی باشد`
					);
				}
				setStepMange(2);
				window.scrollTo(0, 0);
				setButtonCaption("انتخاب زمان ارسال");
				setTitleCaption("مدیریت آدرس ها");
			} else {
				toast.error("سبد خرید شما خالی است");
			}
		}

		if (stepManage === 2) {
			window.scrollTo(0, 0);
			setStepMange(3);
			setButtonCaption("ثبت سفارش");
			setTitleCaption("جزییات سفارش");
			setDetailOrderData({
				detail: shopList.cartItems,
				bank: [{ picBank: pic }],
			});
			checkValidate("addressId");
		} else if (stepManage === 3) {
			window.scrollTo(0, 0);
			checkItems();
		}
	};

	const sendSubmitedData = () => {
		axios
			.post(`${prefixUrl()}/cart/submit.php`, {
				...sendData,
				discountCode: discountContext.code,
				discountPrice: discountContext.discount,
			})
			.then((response) => {
				if (response.data.status) {
					if (sendData.type === "1") {
						window.location.replace(response.data.output);
					}
					if (sendData.type === "2") {
						toast.success(response.data.output);
						localStorage.setItem("products", []);
						setSaleNum(0);
						setTimeout(() => {
							Navigate("/PaymentResult", {
								state: { factorId: sendData.billId },
							});
						}, 1000);
					}

					// Wallet option
					if (sendData.type === "3") {
						// if paymentGateway prop exists, then the wallet balance is not sufficient and should be charged or the method should be changed
						if (response.data.paymentGateway)
							setWalletWarning({
								display: true,
								gateway: response.data.message,
							});
						else {
							toast.success(response.data.output);
							setTimeout(() => {
								Navigate("/PaymentResult", {
									state: { factorId: sendData.billId },
								});
							}, 1000);
						}
					}
				} else {
					toast.error(response.data.output);
				}
			});
	};
	const checkValidate = (name) => {
		if (sendData[name] === "") {
			toast.error("لطفا یک گزینه انتخاب کنید");
			setButtonCaption("انتخاب زمان ارسال");
			setTitleCaption("مدیریت آدرس ها");
			setStepMange(2);
		}
	};
	const checkItems = () => {
		if (sendData.sendingDate === "") {
			toast.error("روز ارسال را انتخاب کنید");
		} else if (sendData.sendingTime === "") {
			toast.error("ساعت ارسال را انتخاب کنید");
		} else if (sendData.type === "") {
			toast.error("نوع ارسال را انتخاب کنید");
		} else {
			sendFactor();
		}
	};
	const submitData = async (name, value) => {
		setSendData((prevState) => {
			return {
				...prevState,
				[name]: value,
			};
		});

		return 1;
	};

	const backBasketHandler = () => {
		setStepMange(stepManage - 1);

		if (stepManage - 1 === 1) {
			setButtonCaption("سبد خرید");
			setTitleCaption("سبد خرید");
		}
		if (stepManage - 1 === 2) {
			setButtonCaption("انتخاب زمان ارسال");
			setTitleCaption("مدیریت آدرس ها");
		}
	};

	// wallet handler
	function useWalletHandler() {
		const [walletWarning, setWalletWarning] = useState({
			display: false,
			gateway: "",
		});
		const [triggerPayment, setTriggerPayment] = useState(false);

		const closeWalletWarningPopup = () => {
			submitData("type", "0");
			setWalletWarning({ display: false, gateway: "" });
			// go back to the first step
			setStepMange(1);
		};

		const selectOnlineWalletWarningPopup = () => {
			submitData("type", "1");
			setWalletWarning({ display: false, gateway: "" });
			setTriggerPayment(true);
		};

		// trigger sendSubmitedData when the client selects to pay online after being shown the digital wallet balance insufficiency warning
		useEffect(() => {
			// setup the condition to prevent unwanted situations trigerring this function
			if (triggerPayment) {
				setTriggerPayment(false);
				sendSubmitedData();
			}
		}, [triggerPayment]);

		return {
			walletWarning,
			setWalletWarning,
			closeWalletWarningPopup,
			selectOnlineWalletWarningPopup,
		};
	}
	const {
		walletWarning,
		setWalletWarning,
		closeWalletWarningPopup,
		selectOnlineWalletWarningPopup,
	} = useWalletHandler();

	return (
		<>
			{/* insufficient digital wallet balance warning modal */}
			{walletWarning.display ? (
				<SmallModal
					onClose={closeWalletWarningPopup}
					icon={WalletPopupIcon}
					iconAlt={"هشدار کیف پول"}
					title={"موجودی کیف پول شما کافی نیست !!!"}
					//op1={weightTypes.length === 0 ? "پرداخت آنلاین" : null}
					//onOp1={selectOnlineWalletWarningPopup}
					op2={"پرداخت آنلاین"}
					onOp2={() => window.location.replace(walletWarning.gateway)}
				/>
			) : (
				""
			)}
			<div className="title-basket">
				<h4>{titleCaption}</h4>
				{stepManage !== 1 && (
					<div className="back-text" onClick={backBasketHandler}>
						<p>بازگشت</p>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="20"
							height="20"
							fill="none"
							viewBox="0 0 20 20"
						>
							<path
								fill="#B9B9B9"
								d="M12.5 17.225a.618.618 0 01-.441-.183l-5.434-5.434a2.283 2.283 0 010-3.216l5.434-5.434a.629.629 0 01.883 0 .629.629 0 010 .884L7.51 9.275c-.4.4-.4 1.05 0 1.45l5.433 5.433a.629.629 0 010 .884.655.655 0 01-.442.183z"
							></path>
						</svg>
					</div>
				)}
			</div>
			{isLoad ? (
				<>
					<div className="main-basket">
						<div className="changing-side">
							{stepManage === 1 ? (
								<div className="row-order-basket">
									{shopList?.cartItems?.length > 0 ? (
										shopList?.cartItems?.map((v, index) => (
											<ListOrder
												key={"L" + index}
												indexNumber={index}
												initialData={v}
												factorTotal={factorTotal}
												setFactorTotal={setFactorTotal}
												total={
													shopList?.cartItems?.length
												}
												productError={productError}
												setReMake={setReMake}
											/>
										))
									) : (
										<span style={{ marginTop: "5rem" }}>
											هیچ محصولی در سبد خرید شما نیست
										</span>
									)}
								</div>
							) : stepManage === 2 ? (
								<AddressSelect
									addressData={addressData}
									onSelect={submitData}
								/>
							) : stepManage === 3 ? (
								<DetailOrder
									detailOrderData={detailOrderData}
									onSelect={submitData}
									weight={weightTypes}
								/>
							) : (
								""
							)}
						</div>

						<div className="fixed-side">
							{weightTypes.length > 0 && (
								<>
									<div className="weight-text">
										<p>
											قیمت به ازای هر مرغ کامل پروتیکا می
											باشد. میانگین وزن هرمرغ کامل پروتیکا
											بین 1.9 تا 2.2 کیلوگرم است (حداقل
											وزن ارسالی 1.9 کیلوگرم خواهد بود).
										</p>

										<p style={{ marginTop: 20 }}>
											در نظر داشته باشید که پس از ثبت
											سفارش، وزن دقیق مرغ کامل پروتیکا در
											فاکتور خرید شما اصلاح خواهد شد.
										</p>
									</div>
								</>
							)}
							{stepManage === 1 && <DiscountCode />}

							<PriceCard
								factorTotal={factorTotal}
								stepManage={stepManage}
							/>
							<div className="button-price-box">
								<DynaButton
									className={"brown-but"}
									onClick={mainActionButton}
								>
									{buttonCaption}
								</DynaButton>
							</div>
						</div>
					</div>
					{stepManage === 1 && (
						<div className="subContainer">
							<Title
								englishTitle={"Latest Products"}
								title={"خرید دیگر مشتریان"}
								showAll={false}
							/>
							<ProductCardContainer
								data={shopList?.products}
								type={"half"}
							/>
						</div>
					)}
				</>
			) : (
				<Loader />
			)}
		</>
	);
};
export default MainBasket;
